import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=ce6c139e&scoped=true"
import script from "./indexs.vue?vue&type=script&lang=js"
export * from "./indexs.vue?vue&type=script&lang=js"
import style0 from "./indexs.vue?vue&type=style&index=0&id=ce6c139e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6c139e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce6c139e')) {
      api.createRecord('ce6c139e', component.options)
    } else {
      api.reload('ce6c139e', component.options)
    }
    module.hot.accept("./indexs.vue?vue&type=template&id=ce6c139e&scoped=true", function () {
      api.rerender('ce6c139e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/previewVideo/indexs.vue"
export default component.exports